import React from 'react';
import { css } from '@emotion/core';
import Link from '../../../shared/Link/Link';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

const DiscountLineBanner = ({ advImages, imageBannerVersion }) => {
  const discountLineStyle = css`
    height: 57px;
    margin-bottom: 32px;
    @media screen and (max-width: 992px) {
      height: 40px;
    }
    .container {
      height: 100%;
      border-radius: 6px;
      max-width: 94%;
      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
        border-radius: 6px;
      }
    }
    &.version-1 {
      .container {
        max-width: 94%;
      }
    }
  `;

  return (
    !!advImages.adv2ImageUrl && (
      <div
        className={`discount-image-container version-${imageBannerVersion}`}
        css={discountLineStyle}
      >
        <div className="container">
          {advImages.adv2Link ? (
            advImages.adv2Link.includes('https') ? (
              <a href={advImages.adv2Link} rel="noreferrer" target="_blank">
                <ImageDispatcher
                  src={advImages.adv2ImageUrl}
                  alt={`Immagine relativa alla pagina ${(
                    advImages.adv2Link || ''
                  ).replace(/\//g, '')}`}
                />
              </a>
            ) : (
              <Link to={advImages.adv2Link}>
                <ImageDispatcher
                  src={advImages.adv2ImageUrl}
                  alt={`Immagine relativa alla pagina ${(
                    advImages.adv2Link || ''
                  ).replace(/\//g, '')}`}
                />
              </Link>
            )
          ) : (
            <ImageDispatcher
              src={advImages.adv2ImageUrl}
              alt="Immagine pubblicitaria lineare banner"
            />
          )}
        </div>
      </div>
    )
  );
};
export default DiscountLineBanner;
